import { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { api } from "@/lib/api";
import { Navbar } from "@/components/site/Navbar";
import { KineticHero } from "@/components/site/KineticHero";
import { EditorialMarquee } from "@/components/site/Marquee";
import { Products } from "@/components/site/Products";
import { About } from "@/components/site/About";
import { Testimonials } from "@/components/site/Testimonials";
import { WhatsAppButton } from "@/components/site/WhatsAppButton";
import { Footer } from "@/components/site/Footer";

const Loader = () => (
  <div className="min-h-screen flex items-center justify-center bg-forest-900">
    <div className="h-12 w-12 rounded-full border-2 border-sand/20 border-t-terracotta-500 animate-spin" />
  </div>
);

export default function Home() {
  const [content, setContent] = useState(null);
  const [products, setProducts] = useState([]);
  const [testimonials, setTestimonials] = useState([]);

  useEffect(() => {
    Promise.all([
      api.get("/content").then((r) => setContent(r.data)),
      api.get("/products").then((r) => setProducts(r.data)),
      api.get("/testimonials").then((r) => setTestimonials(r.data)).catch(() => {}),
    ]).catch(() => {});
  }, []);

  if (!content) return <Loader />;

  return (
    <div className="bg-sand grain">
      <Helmet>
        <title>{`${content.brand_name} | Productos Naturales, Té Detox y Café Funcional`}</title>
        <meta name="description" content={content.hero_subtitle} />
        <meta property="og:title" content={`${content.brand_name} | ${content.hero_title}`} />
        <meta property="og:description" content={content.hero_subtitle} />
      </Helmet>
      <Navbar content={content} />
      <KineticHero content={content} />
      <EditorialMarquee />
      <Products products={products} content={content} />
      <About content={content} />
      <Testimonials testimonials={testimonials} />
      <Footer content={content} />
      <WhatsAppButton content={content} />
    </div>
  );
}
